import type { SxProps, Theme } from "@mui/material/styles";

export const root: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  flexWrap: "wrap",
  gap: 2,
};

export const textBlock: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  gap: 0.625,
};

export const title: SxProps<Theme> = {
  fontSize: { xs: "1.25rem", sm: "1.5rem" },
  fontWeight: 700,
  lineHeight: 1.2,
};

export const subtitle: SxProps<Theme> = {
  fontSize: "0.84375rem",
  color: "text.secondary",
  lineHeight: 1.5,
};
